function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.2637 16.5C21.5055 16.5 21.7129 16.6731 21.7559 16.9111L22.2959 19.9111C22.3511 20.2178 22.1153 20.5 21.8037 20.5H6.19629C5.88469 20.5 5.6489 20.2178 5.7041 19.9111L6.24414 16.9111C6.28713 16.6731 6.49446 16.5 6.73633 16.5H21.2637Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.7559 5.5127C21.0164 5.64082 22 6.70566 22 8C22 9.38071 20.8807 10.5 19.5 10.5H8.5C7.11929 10.5 6 9.38071 6 8C6 6.70566 6.98361 5.64082 8.24414 5.5127L8.5 5.5H19.5L19.7559 5.5127ZM8.5 6.5C7.67157 6.5 7 7.17157 7 8C7 8.82843 7.67157 9.5 8.5 9.5C9.32843 9.5 10 8.82843 10 8C10 7.17157 9.32843 6.5 8.5 6.5ZM19.5 6.5C18.6716 6.5 18 7.17157 18 8C18 8.82843 18.6716 9.5 19.5 9.5C20.3284 9.5 21 8.82843 21 8C21 7.17157 20.3284 6.5 19.5 6.5Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25 2.5C25.2761 2.5 25.5 2.72386 25.5 3V13C25.5 13.2761 25.2761 13.5 25 13.5H3C2.72386 13.5 2.5 13.2761 2.5 13V3C2.5 2.72386 2.72386 2.5 3 2.5H25ZM8.5 4.5C6.567 4.5 5 6.067 5 8C5 9.933 6.567 11.5 8.5 11.5H19.5C21.433 11.5 23 9.933 23 8C23 6.067 21.433 4.5 19.5 4.5H8.5Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27 0C27.5523 0 28 0.447715 28 1V19C28 19.5523 27.5523 20 27 20H23.3018C23.3016 19.9126 23.2964 19.8239 23.2803 19.7344L22.7402 16.7344C22.6116 16.0199 21.9896 15.5 21.2637 15.5H6.73633C6.0104 15.5 5.38837 16.0199 5.25977 16.7344L4.71973 19.7344C4.70363 19.8239 4.69842 19.9126 4.69824 20H1C0.447715 20 8.05325e-09 19.5523 0 19V1C1.28852e-07 0.447715 0.447715 2.41596e-08 1 0H27ZM3 1.5C2.17157 1.5 1.5 2.17157 1.5 3V13C1.5 13.8284 2.17157 14.5 3 14.5H25C25.8284 14.5 26.5 13.8284 26.5 13V3C26.5 2.17157 25.8284 1.5 25 1.5H3Z",
  fill: "white"
});

var SvgIndie = function SvgIndie(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIndie, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/indie.226ab5a1.svg";
export { ForwardRef as ReactComponent };